export default __webpack_public_path__ + "static/media/Drinking.d9a2c516.svg";